import { type FC, type ReactNode } from 'react';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';

import KiosImage from 'modules/quick-search/components/KiosImage';

interface Props {
  image?: string | null;
  title: string;
  description?: string | null;
  /** Nhãn số lượng cấp con (vd "(6) NMH" ở PLHH, "(5) HSNL NCC" ở NMH). */
  countLabel?: ReactNode;
  selected?: boolean;
  onClick: () => void;
}

/** Card lưới cho 1 mục PLHH/NMH: ảnh trên + tiêu đề + số lượng cấp con + mô tả. */
const CategoryCard: FC<Props> = ({
  image,
  title,
  description,
  countLabel,
  selected = false,
  onClick,
}) => {
  return (
    <CardActionArea
      onClick={onClick}
      sx={{
        borderRadius: 2,
        overflow: 'hidden',
        bgcolor: 'background.paper',
        boxShadow: 2,
        border: 2,
        borderColor: selected ? 'primary.main' : 'transparent',
        transition: 'box-shadow .2s, border-color .2s',
        '&:hover': { boxShadow: 4 },
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}
    >
      <Box
        sx={{
          height: 200,
          bgcolor: 'action.hover',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <KiosImage
          src={image}
          alt={title}
          fallbackIconSize={48}
          sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </Box>

      <Box sx={{ p: 2, flexGrow: 1 }}>
        <Typography sx={{ fontWeight: 700, color: 'primary.main', mb: 0.5 }}>{title}</Typography>
        {countLabel != null && (
          <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
            {countLabel}
          </Typography>
        )}
        {description ? (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {description}
          </Typography>
        ) : null}
      </Box>
    </CardActionArea>
  );
};

export default CategoryCard;
